import { useState } from "react"
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { toast } from "react-toastify"
import { selector, Headers } from "../../../api"
import { authCRUD } from "../../../actions/auth"

const passSchema = Yup.object().shape({
  old_password: Yup.string().min(8, 'Must Contain atleast 8 Characters').required('Old Password is required'),
  new_password: Yup.string().min(8, 'Must Contain atleast 8 Characters').required('New Password is required'),
  confirmPassword: Yup.string().oneOf([Yup.ref("new_password"), null], "Passwords must match").required('Confirm Password is required'),
})

export const PasswordContent = () => {

  const user = selector.User()
  const accessToken = selector.AccessToken()
  const [loading, setLoading] = useState(false)
  const [oChecked, setOChecked] = useState(false)
  const [nChecked, setNChecked] = useState(false)
  const [cChecked, setCChecked] = useState(false)

  const passValues = {
    old_password: '',
    new_password: '',
    confirmPassword: '',
  }

  const passFormik = useFormik({
    initialValues: passValues,
    validationSchema: passSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      const { old_password, new_password } = values
      const data = { old_password, new_password }
      setLoading(true)
      setTimeout(() => {
        authCRUD.updatePassword(user.id, data, Headers(accessToken)).then(() => {
          toast.success('Your password has been update.', { autoClose: 7000 })
          resetForm()
        }).catch((error) => {
          setLoading(false)
          setSubmitting(false)
          toast.error(error.message, { autoClose: 7000 })
        }).finally(() => {
          setLoading(false)
          setSubmitting(false)
        })
      }, 2000)
    }
  })

  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xxl-9 mx-auto">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title mb-0">
                      <i className="far fa-user me-1"></i> Change Password
                    </h5>
                  </div>
                  <div className="card-body p-4">
                    <form onSubmit={passFormik.handleSubmit}>
                      <div className="row g-2">
                        <div className="col-lg-12">
                          <div>
                            <label htmlFor="oldpasswordInput" className="form-label">Old Password <span className="text-danger">*</span></label>
                            <div className="position-relative auth-pass-inputgroup">
                              <input type={oChecked ? "text" : "password"} className="form-control" id="oldpasswordInput" placeholder="Enter current password" {...passFormik.getFieldProps('old_password')} />
                              <button onClick={() => setOChecked(!oChecked)} className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon" type="button">
                                <i className={oChecked ? "bi bi-eye-slash-fill" : "bi bi-eye-fill"} style={{ fontSize: '15px' }}></i>
                              </button>
                            </div>
                            {passFormik.touched.old_password && passFormik.errors.old_password && (
                              <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                                <span role='alert' className='text-danger'>{passFormik.errors.old_password}</span>
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div>
                            <label htmlFor="newpasswordInput" className="form-label">New Password*</label>
                            <div className="position-relative auth-pass-inputgroup">
                              <input type={nChecked ? "text" : "password"} className="form-control" id="newpasswordInput" placeholder="Enter new password" {...passFormik.getFieldProps('new_password')} />
                              <button onClick={() => setNChecked(!nChecked)} className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon" type="button">
                                <i className={nChecked ? "bi bi-eye-slash-fill" : "bi bi-eye-fill"} style={{ fontSize: '15px' }}></i>
                              </button>
                            </div>
                            {passFormik.touched.new_password && passFormik.errors.new_password && (
                              <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                                <span role='alert' className='text-danger'>{passFormik.errors.new_password}</span>
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div>
                            <label htmlFor="confirmpasswordInput" className="form-label">Confirm Password*</label>
                            <div className="position-relative auth-pass-inputgroup">
                              <input type={cChecked ? "text" : "password"} className="form-control" id="confirmpasswordInput" placeholder="Confirm new password" {...passFormik.getFieldProps('confirmPassword')} />
                              <button onClick={() => setCChecked(!cChecked)} className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon" type="button">
                                <i className={cChecked ? "bi bi-eye-slash-fill" : "bi bi-eye-fill"} style={{ fontSize: '15px' }}></i>
                              </button>
                            </div>
                            {passFormik.touched.confirmPassword && passFormik.errors.confirmPassword && (
                              <div className='fw-light h6 mt-1' style={{ fontSize: '15px' }}>
                                <span role='alert' className='text-danger'>{passFormik.errors.confirmPassword}</span>
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-12">
                          <div className="text-end">
                            <button type='submit' className="btn btn-soft-success" disabled={passFormik.isSubmitting || !passFormik.isValid}>
                              {!loading && <span className='indicator-label'><i className="las la-save la-lg"></i> save changes </span>}
                              {loading && (
                                <span className='indicator-progress' style={{ display: 'block' }}>
                                  Please wait...
                                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
